import type { ReactNode } from 'react'
import { Reveal } from './Reveal'

// Landing section header — the display headline carries the section; no standing
// mono "// NN · LABEL" eyebrow (de-slop). index/kicker kept for back-compat only.
export function SectionHeader({ title, sub, align = 'left' }: {
  index?: string; kicker?: string; title: ReactNode; sub?: ReactNode; align?: 'left' | 'center'
}) {
  return (
    <Reveal className={`section-header section-header--${align}`}>
      <h2 className="section-title">{title}</h2>
      {sub && <p className="section-sub">{sub}</p>}
    </Reveal>
  )
}
